/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesDraftTeamSchema } from "./draftTeamSchema.ts";
import { goodLuckCoreEntitiesGameRoleSchema } from "./gameRoleSchema.ts";
import { goodLuckCoreEntitiesRiotAccountSchema } from "./riotAccountSchema.ts";
import { goodLuckCoreEntitiesTournamentRoleSchema } from "./tournamentRoleSchema.ts";
import { goodLuckCoreEntitiesTournamentSchema } from "./tournamentSchema.ts";
import { goodLuckCoreEntitiesUserSchema } from "./userSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesDraftPlayerSchema = z.object({
  id: z.string().nullish(),
  tournamentId: z.string().nullish(),
  userId: z.string().nullish(),
  riotAccountId: z.string().nullish(),
  get mainRole() {
    return goodLuckCoreEntitiesGameRoleSchema.optional();
  },
  get secondaryRole() {
    return goodLuckCoreEntitiesGameRoleSchema.optional();
  },
  get desiredRole() {
    return goodLuckCoreEntitiesTournamentRoleSchema.optional();
  },
  playerNote: z.string().nullish(),
  cost: z.optional(z.int()),
  rank: z.string().nullish(),
  moderatorAdjustedCost: z.int().nullish(),
  moderatorComment: z.string().nullish(),
  isSelected: z.optional(z.boolean()),
  selectedByTeamId: z.string().nullish(),
  selectedAt: z.iso.datetime().nullish(),
  get tournament() {
    return goodLuckCoreEntitiesTournamentSchema.optional();
  },
  get user() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
  get riotAccount() {
    return goodLuckCoreEntitiesRiotAccountSchema.optional();
  },
  get selectedByTeam() {
    return goodLuckCoreEntitiesDraftTeamSchema.optional();
  },
});
